import Instance from "../../../../Axios";

// New Actions for the app

const GetCredAeroportos = () => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/aeroportos`)
    .then(({ data }) => {
      dispatch({
        type: "GET_CRED_AEROPORTOS",
        payload: data.yData,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCredAeroportos;
